import React from 'react';
import { MenuItem, TextField, Tooltip } from "@mui/material";
import { Filter } from "../Filter";
import { useTranslation } from "react-i18next";
import { useAppSelector } from "../../../../commons/store/hooks";
import { selectMedicalCenters } from "../../../medicalCenters/redux/medicalCentersSlice";

export interface FilterPanelProps {}

export const FilterPanel = (props: FilterPanelProps) => {
    const { t } = useTranslation();
    const medicalCenters = useAppSelector(selectMedicalCenters);

    const filters: any[] = [
        {
            render: (filter: any, fn: any) => (
                <Tooltip title={t('randomization-number')} arrow>
                    <TextField
                        label={t('randomization-number')}
                        value={filter?.['datas.ecrf.randomId'] || ''}
                        onChange={(event) =>
                            fn(event.target.value, 'datas.ecrf.randomId')
                        }
                        fullWidth
                        variant={'outlined'}
                        size={'small'}
                    />
                </Tooltip>
            ),
            key: 'datas.ecrf.randomId',
        },
        {
          render: (filter: any, fn: any) => (
            <Tooltip title={t('screening-number')} arrow>
              <TextField
                label={t('screening-number')}
                value={filter?.['screeningNumber'] || ''}
                onChange={(event) =>
                  fn(event.target.value, 'screeningNumber')
                }
                fullWidth
                variant={'outlined'}
                size={'small'}
              />
            </Tooltip>
          ),
          key: 'screeningNumber',
        },
        {
          render: (filter: any, fn: any) => (
            <Tooltip title={t('select-research-center')} arrow>
              <TextField
                label={t('medical-center')}
                select
                fullWidth
                variant={'outlined'}
                size={'small'}
                value={filter?.['datas.ecrf.medicalCenter'] || ''}
                onChange={(event) =>
                  fn(event.target.value, 'datas.ecrf.medicalCenter')
                }
              >
                {/** Display list of all numbers */}
                {medicalCenters?.data?.map((center: any, index) => (
                  <MenuItem key={center?.id} value={center.id}>
                    {center?.number} {' | '} {center?.name}
                  </MenuItem>
                ))}
              </TextField>
            </Tooltip>
          ),
          key: 'datas.ecrf.medicalCenter',
        },
    ];

    return <Filter elements={filters} />;
};
